import { handleClientError } from "lib/errors";
import { groq } from "next-sanity";
import { getClient } from "../sanity";

/**
 * The set of available "featured customers" that we have hardcoded copy available to display
 * in the `CustomerStats` component.
 */
export type FeaturedCustomerSlug =
  | "auto-trader"
  | "gorgias"
  | "lucidchart"
  | "minno"
  | "petsmart"
  | "wmg"
  | "the-zebra";

export type Customer = {
  slug: string;
  name: string;
  website: string;
  about?: string;
  logoUrl: string;
  logoMonoUrl?: string;
};

export const customerFragment =
  "slug, name, website, about, 'logoUrl': logo.asset->url, 'logoMonoUrl': logoMonotone.asset->url";

export const getCustomers = async (): Promise<Customer[]> => {
  const query = groq`
    *[_type == "customer"] {
      ${customerFragment}
    }
  `;
  const customers = await getClient().fetch(query);
  return customers;
};

export const getFeaturedCustomers = async (slugs: FeaturedCustomerSlug[]): Promise<Customer[]> => {
  const query = groq`
    *[_type == "customer" && slug in [${slugs.map((slug) => "'" + slug + "'")}]] {
      ${customerFragment}
    }
  `;
  const unorderedCustomers: Customer[] = await getClient().fetch(query);
  const orderedCustomers: Customer[] = [];

  // Return the customers in the same order they were requested
  for (const slug of slugs) {
    const customerRecord = unorderedCustomers.find((customer: Customer) => customer.slug === slug);

    if (customerRecord) {
      orderedCustomers.push(customerRecord);
    } else {
      handleClientError(
        new Error(
          `There was an issue loading featured customers from Sanity. Expected a customer with slug '${slug}' to exist.`,
        ),
      );
    }
  }

  return orderedCustomers;
};
